<template>
  <div class="wrapper">
    <parallax
            class="page-header header-filter clear-filter"
            parallax-active="false" style="background: #3F7CB3"
    >
      <block-main />
    </parallax>
    <div class="main main-raised">

      <second-block />
      <block-polza />
      <block-features />
      <block-comments />
      <block-price />
      <block-contact />
      <block-support />
    </div>

  </div>
</template>

<script>

  import SecondBlock from '../components/Custom/SecondBlock.vue';
  import Mixins from "@/plugins/basicMixins";
  import BlockPolza from "../components/Custom/BlockPolza";
  import BlockFeatures from "../components/Custom/BlockFeatures";
  import BlockComments from "../components/Custom/BlockComments";
  import BlockPrice from "../components/Custom/BlockPrice";
  import BlockContact from "../components/Custom/BlockContact";
  import BlockSupport from "../components/Custom/BlockSupport";
  import BlockMain from "../components/Custom/BlockMain";


  export default {
    components: {
      SecondBlock,
      BlockPolza,
      BlockFeatures,
      BlockComments,
      BlockPrice,
      BlockContact,
      BlockSupport,
      BlockMain
    },
    bodyClass: "presentation-page",
    props: {
    },
    data() {
      return {
        leafShow: false
      };
    },
    mounted() {
      this.leafActive();
      window.addEventListener("resize", this.leafActive);
      document.addEventListener("scroll", this.scrollListener);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.leafActive);
      document.removeEventListener("scroll", this.scrollListener);
    },
    methods: {
      leafActive() {
        if (window.innerWidth < 768) {
          this.leafShow = false;
        } else {
          this.leafShow = true;
        }
      }
    }
  };
</script>

<style lang="scss"></style>
